import { createHandlerChainRunner, Handler } from "@insite/client-framework/HandlerCreator";
import { CustomHandler } from "@tCentro/Store/CustomHandlerCreator";

type HandlerType = CustomHandler<{ OrderNotes: string }>;

export const DispatchSetOrderNotes: HandlerType = props => {
    props.dispatch({
        type: "Custom/CheckoutReview/SetOrderNotes",
        OrderNotes: props.parameter.OrderNotes,
    });
};

export const chain = [DispatchSetOrderNotes];

const setOrderNotes = createHandlerChainRunner(chain, "setOrderNotes");
export default setOrderNotes;
